module.exports = __webpack_public_path__ + "img/default-cheese.96a80e92.svg";